export default "__VITE_ASSET__Gj_2tiji__"